import { defineReactiveModel, Persistable } from "vue-app-utils";
import Model from "@/models/model";

const ReadonlyCart = {
  extends: Model,
  mixins: [
    Persistable
  ]
};

export default defineReactiveModel(ReadonlyCart);
